import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function ToolsPage() {
  // Add scroll to top on mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const tools = [
    {
      title: 'Cost of Living Calculator',
      description: 'Compare living expenses between USA and Ireland cities',
      icon: 'ri-calculator-line',
      color: 'from-emerald-500 to-teal-600',
      link: '/tools/cost-calculator'
    },
    {
      title: 'Salary Converter',
      description: 'Convert US salaries to Irish equivalents with tax calculations',
      icon: 'ri-money-dollar-circle-line',
      color: 'from-blue-500 to-indigo-600',
      link: '/tools/salary-converter'
    },
    {
      title: 'Visa Eligibility Quiz',
      description: 'Find out which Irish visa type you qualify for',
      icon: 'ri-passport-line',
      color: 'from-purple-500 to-pink-600',
      link: '/tools/visa-quiz'
    },
    {
      title: 'Moving Checklist',
      description: 'Track your relocation tasks with our comprehensive checklist',
      icon: 'ri-checkbox-multiple-line',
      color: 'from-orange-500 to-red-600',
      link: '/tools/checklist'
    },
    {
      title: 'Budget Planner',
      description: 'Create detailed monthly budget comparing USA vs Ireland expenses',
      icon: 'ri-pie-chart-line',
      color: 'from-green-500 to-emerald-600',
      link: '/tools/budget-planner'
    },
    {
      title: 'Timeline Planner',
      description: 'Step-by-step timeline from 12 months before to first month in Ireland',
      icon: 'ri-calendar-check-line',
      color: 'from-cyan-500 to-blue-600',
      link: '/tools/timeline-planner'
    }
  ];

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar scrolled={scrolled} />
      
      {/* Header - Added pt-32 to account for fixed navbar */}
      <section className="pt-32 pb-16 px-6 bg-[#0A381F] text-white">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Relocation Tools</h1>
          <p className="text-xl text-white/80 max-w-3xl">Free calculators and resources to plan your move to Ireland</p>
        </div>
      </section>

      {/* Tools Grid */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-8">
            {tools.map((tool) => (
              <Link
                key={tool.title}
                to={tool.link}
                className="group bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
              >
                <div className={`w-16 h-16 flex items-center justify-center ${tool.color} text-white rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${tool.icon} text-3xl`}></i>
                </div>
                <h3 className="text-2xl font-bold text-[#0A381F] mb-3 group-hover:text-[#D4AF37] transition-colors">
                  {tool.title}
                </h3>
                <p className="text-gray-600 mb-4">{tool.description}</p>
                <div className="flex items-center text-[#D4AF37] font-semibold group-hover:gap-3 transition-all duration-300">
                  <span>Get Started</span>
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xl"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-[#0A381F] mb-6">Need Personalized Guidance?</h2>
          <p className="text-xl text-gray-600 mb-8">
            Connect with verified immigration lawyers, relocation specialists, and expat advisors who can provide tailored support for your unique situation.
          </p>
          <Link
            to="/directory"
            className="inline-block bg-[#D4AF37] hover:bg-[#C19B2F] text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Browse Expert Directory
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
